import * as React from 'react';
import { StyleSheet, css } from 'aphrodite/no-important';
import { generateLinkStyleFromTheme, TextLinkComponent } from '../../../partials/link/TextLink';
import { VrLineHeight } from '../../../../theming/verticalRhythm/verticalRhythm';
import { useTheme } from '../../../../theming/useTheme';
import { MEDIA_BREAKPOINTS } from '../../../../mediaQueries.const';

const componentConfigurationKey = 'bottomFooterBar';

interface BottomFooterBarThemeProps {
  backgroundColor: string,
  vrLineHeight: VrLineHeight
  textColor: string
}

export interface BottomFooterBarDataProps {
  year: number,
  rightsReservedText: string,
  poweredByLink: {
    text: string,
    href: string
  }
}

type BottomFooterBarProps = BottomFooterBarDataProps & BottomFooterBarThemeProps;

const getBottomFooterBarStyle = ({ backgroundColor, vrLineHeight, textColor }: BottomFooterBarThemeProps) => StyleSheet.create({
  style: {
    backgroundColor,
    color: textColor,
    [MEDIA_BREAKPOINTS.X_LARGE]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.X_LARGE] * 0.5}px`,
    },
    [MEDIA_BREAKPOINTS.LARGE]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.LARGE] * 0.5}px`,
    },
    [MEDIA_BREAKPOINTS.MEDIUM]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.MEDIUM] * 0.5}px`,
      textAlign: 'center',
    },
    [MEDIA_BREAKPOINTS.SMALL]: {
      padding: `${vrLineHeight[MEDIA_BREAKPOINTS.SMALL] * 0.5}px`,
      textAlign: 'center',
    },
  },
});

export const BottomFooterBarComponent: React.FunctionComponent<BottomFooterBarProps> = props => {
  const bottomFooterBarStyle = getBottomFooterBarStyle(props);
  const { textColor, year, rightsReservedText, poweredByLink } = props;
  const linkStyle = generateLinkStyleFromTheme({ idleColor: textColor, activeStateColor: textColor, hoverStateColor: textColor });

  return (
    <p className={css(bottomFooterBarStyle.style)}>
      <TextLinkComponent href={poweredByLink.href} linkStyle={linkStyle} rel="noopener" target="_blank">
        {poweredByLink.text}
      </TextLinkComponent>
      {` © ${year} ${rightsReservedText}`}
    </p>
  );
};

const mapThemeProps = (theme: BottomFooterBarThemeProps) => {
  return {
    backgroundColor: theme.backgroundColor,
    vrLineHeight: theme.vrLineHeight,
    textColor: theme.textColor,
  };
};

export const BottomFooterBar = (props: BottomFooterBarDataProps) => {
  const themeContext = useTheme(componentConfigurationKey, mapThemeProps);
  return <BottomFooterBarComponent {...themeContext} {...props} />;
};
